module.exports = __webpack_public_path__ + "r-v3/img/sticker_21_icon.e4150935.svg";